webpackJsonp([897551957352],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(4);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twitter = __webpack_require__(23);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _facebook = __webpack_require__(17);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _googlePlus = __webpack_require__(22);
	
	var _googlePlus2 = _interopRequireDefault(_googlePlus);
	
	var _envelope = __webpack_require__(28);
	
	var _envelope2 = _interopRequireDefault(_envelope);
	
	var _pinterest = __webpack_require__(30);
	
	var _pinterest2 = _interopRequireDefault(_pinterest);
	
	var _linkedin = __webpack_require__(29);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _reactCustomShare = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiveShareButtonRoundSquare = function LiveShareButtonRoundSquare(props) {
	  var shareBlockProps = {
	    url: "https://github.com/greglobinski/react-custom-share",
	    button: _reactCustomShare.ShareButtonRoundSquare,
	    buttons: [{ network: "Twitter", icon: _twitter2.default }, { network: "Facebook", icon: _facebook2.default }, { network: "GooglePlus", icon: _googlePlus2.default }, { network: "Email", icon: _envelope2.default }, {
	      network: "Pinterest",
	      icon: _pinterest2.default,
	      media: "https://raw.githubusercontent.com/greglobinski/react-custom-share/master/static/react-custom-share.gif"
	    }, { network: "Linkedin", icon: _linkedin2.default }],
	    text: "Give it a try - react-custom-share component",
	    longtext: "Social sharing buttons for React. Use one of the build-in themes or create a custom one from the scratch."
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "h2",
	      {
	        className: "jsx-3110979548"
	      },
	      "ShareBlock - live demo"
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        className: "jsx-3110979548"
	      },
	      _react2.default.createElement(_reactCustomShare.ShareBlockStandard, shareBlockProps)
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "3110979548",
	      css: ["div.jsx-3110979548{max-width:600px;margin:100px auto;text-align:center;}", "h2.jsx-3110979548{color:#666;font-size:1.2em;margin:3em 0;text-align:center;}"]
	    })
	  );
	};
	
	exports.default = LiveShareButtonRoundSquare;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-live-share-button-round-square-js-0c94ab433baa985d835f.js